// @flow
/* globals document, window */
import React from "react";
import classNames from "classnames";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";
import Input from "elevate-ui/Input";
import Button from "elevate-ui/Button";
import { withSellerLeadContext } from "../common/SellerLeadContext";
import { withGlobalContext } from "../common/GlobalContext";

type $Props = {
  classes: Object,
  handlePage2: Function,
  location: { lat: number, lng: number },
  address: Object,
  mapProvider: Object,
  buttonColor: string,
  privacyPolicy: Object,
};

let MapComponent = () => <div />;
class SellerPage2 extends React.Component<$Props> {
  constructor(props: $Props) {
    super(props);
    MapComponent = require("./SellerMap").default;
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {
      classes,
      address,
      handlePage2,
      mapProvider,
      location,
      privacyPolicy,
    } = this.props;
    return (
      <div className={classNames(classes.boxWrapper)}>
        <div className={classes.box}>
          <Typography type="title" className={classes.boxTitle}>
            {address.value.street} Found!
          </Typography>
          <div className={classes.row}>
            {location &&
              location.lat &&
              location.lng && (
                <div className={classes.mapWrapper}>
                  <MapComponent
                    mapTypeId={mapProvider.tileLayers.street}
                    scrollWheelZoom={false}
                    zoom={13}
                    location={location}
                    {...this.props}
                  />
                </div>
              )}
            <div>
              <Formik
                initialValues={{ name: "", email: "" }}
                validationSchema={() =>
                  Yup.object().shape({
                    name: Yup.string().required("Name is required"),
                    email: Yup.string()
                      .email("Invalid email address")
                      .required("Email is required"),
                  })
                }
                onSubmit={(values, { setSubmitting }) => {
                  handlePage2(values);
                  setSubmitting(false);
                }}
                render={({ errors, touched }) => (
                  <Form noValidate>
                    <div className={classes.boxForm}>
                      <Typography type="body" className={classes.boxText}>
                        Where Should We Send Your Report?
                      </Typography>
                      <div className={classes.emailInputWrapper}>
                        <Field
                          id="email"
                          name="email"
                          placeholder="Enter Email"
                          component={Input}
                          className={classNames(
                            classes.emailInput,
                            errors.email && touched.email
                              ? classes.invalid
                              : null
                          )}
                          withScaffold={false}
                        />
                        {errors.email &&
                          touched.email && (
                            <div className={classes.inputInvalid}>
                              {errors.email}
                            </div>
                          )}
                      </div>
                      <div className={classes.nameInputWrapper}>
                        <Field
                          id="name"
                          name="name"
                          placeholder="Name"
                          component={Input}
                          className={classNames(
                            classes.nameInput,
                            errors.name && touched.name ? classes.invalid : null
                          )}
                          withScaffold={false}
                        />
                        {errors.name &&
                          touched.name && (
                            <div className={classes.inputInvalid}>
                              {errors.name}
                            </div>
                          )}
                      </div>
                      <div className={classes.helperText}>
                        (For Address Match Verification)
                      </div>

                      <Button
                        color={this.props.buttonColor}
                        className={classes.button}
                        type="submit"
                        innerClassName={classes.buttonInner}
                      >
                        Send Me My Value >>
                      </Button>
                      <div className={classes.helperTextUnderButton}>
                        Protecting Your Privacy Is A Top Priority.
                      </div>
                      <div className={classes.helperTextPadding}>
                        By using this site, you agree to our{" "}
                        <a
                          className={classes.link}
                          href={"/terms?withoutLayout=true"}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Terms
                        </a>
                        {" and "}
                        <a
                          className={classes.link}
                          href={`${privacyPolicy.href}?withoutLayout=true`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Privacy Policy.
                        </a>
                      </div>
                    </div>
                  </Form>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const styles = (theme) => {
  const tabletL = 992;
  const tabletP = 768;
  const mobile = 480;

  return {
    boxWrapper: {
      width: "100%",
      [`@media (min-width: ${tabletP}px)`]: {
        width: "80%",
      },
      maxWidth: "1000px",
      display: "flex",
      zIndex: "1",
      position: "relative",
      flexFlow: "column",
      [`@media (min-width: ${mobile}px)`]: {
        marginTop: "calc(3% - 20px)",
      },
      marginBottom: "calc(10%)",
      alignItems: "center",
      justifyContent: "center",
    },
    box: {
      borderRadius: `${theme.spacing.unit * 1.5}px`,
      backgroundColor: theme.colors.white,
      padding: `${theme.spacing.unit * 0.5}px ${theme.spacing.unit}px`,
      [`@media (min-width: ${tabletP}px)`]: {
        padding: `${theme.spacing.unit * 2}px`,
      },
      [`@media (min-width: ${tabletL}px)`]: {
        padding: `${theme.spacing.unit * 3}px`,
      },
      textAlign: "center",
      boxShadow: theme.shadows[4],
    },
    row: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexWrap: "wrap",
      [`@media (min-width: ${tabletL}px)`]: {
        flexWrap: "nowrap",
      },
    },
    boxTitle: {
      lineHeight: "1.2",
      fontWeight: "normal",
      fontSize: "30px",
    },
    boxText: {
      fontSize: "24px",
      padding: `0 0 ${theme.spacing.unit * 0.5}px 0`,
      [`@media (min-width: ${mobile}px)`]: {
        padding: `0 0 ${theme.spacing.unit}px 0`,
      },
      [`@media (min-width: ${tabletL}px)`]: {
        padding: `0 0 ${theme.spacing.unit * 1.5}px 0`,
      },
    },
    boxForm: {
      width: "100%",
    },
    emailInputWrapper: { marginBottom: `${theme.spacing.unit * 0.5}px` },
    emailInput: {
      borderRadius: "4px",
      backgroundColor: "#ebffff",
    },
    nameInputWrapper: { marginBottom: `${theme.spacing.unit * 0.5}px` },
    nameInput: {
      borderRadius: "4px",
      backgroundColor: "#ebffff",
    },
    inputInvalid: {
      fontSize: "12px",
      marginTop: "4px",
      marginLeft: "14px",
      textAlign: "left",
      color: "darkred",
    },
    invalid: { backgroundColor: "#ffd8d8", borderColor: "red" },
    button: { width: "100%", padding: "2px 0" },
    buttonInner: {
      color: theme.colors.white,
      fontSize: "20px",
      textShadow: "1px 1px #521601",
      fontWeight: "700",
      whiteSpace: "nowrap",
    },
    mapWrapper: {
      padding: `${theme.spacing.unit * 0.5}px`,
      [`@media (min-width: ${mobile}px)`]: {
        padding: `${theme.spacing.unit}px`,
      },
    },
    helperTextUnderButton: {
      marginTop: "4px",
      marginBottom: theme.spacing.unit,
      fontSize: "12px",
      fontWeight: "bold",
    },
    helperText: {
      marginTop: "4px",
      marginBottom: theme.spacing.unit,
      fontSize: "12px",
    },
    helperTextPadding: {
      paddingTop: `${theme.spacing.unit}px`,
      marginBottom: theme.spacing.unit,
      fontSize: "12px",
      lineHeight: "1.4",
    },
    link: { textDecoration: "none", color: "inherit" },
  };
};

export default withGlobalContext(
  withSellerLeadContext(withStyles(styles)(SellerPage2))
);
